<mat-card class="coverage-table-widget-container">
  <div #exportContent>
    <div class="header">
      <div class="span">Counties With Least Coverage</div>
      <button class="header-btn" data-html2canvas-ignore mat-icon-button (click)="export()">
        <vulcan-icon size="24px" icon="download"></vulcan-icon>
      </button>
    </div>
    <div class="content">
      <div class="sub-header"> {{ countiesWithLeastCoverage().length }} Counties have less than 50% coverage:</div>
      <ul>
        @for (county of countiesWithLeastCoverage(); track county.name) {
          <li class="county">
            <div class="county-row">
              <span>{{ county.name }}:</span>
              <span class="number">{{ county.percentage | number : '1.0-2' }}%</span>
            </div>
          </li>
        }
      </ul>
      <br/>
      <div class="sub-header"> {{ countiesWithNoData().length }} Counties have no data:</div>
      <ul>
        @for (county of countiesWithNoData(); track county.name) {
          <li class="county">
            <div class="county-row">
              <span>{{ county.name }}:</span>
            </div>
          </li>
        }
      </ul>
    </div>
  </div>
</mat-card>
